var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavOffersLogout = function SvgNavOffersLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "nav_offers_logout_svg__Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".nav_offers_logout_svg__st0{fill:none;stroke:#666;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "nav_offers_logout_svg__st0",
    d: "M24.1 15.3H31v16.5h-6.5M15.4 23.6h10.4"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#666",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "m19.6 19.3-4.3 4.2 4.3 4.3"
  }));
};
export default SvgNavOffersLogout;